import React, { useContext, useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';

import ReCAPTCHA from 'react-google-recaptcha';
import { FaEyeSlash, FaEye } from 'react-icons/fa';
import { Button, Form, Modal } from 'react-bootstrap';

import styles from './Login.module.css';
import { UserContext } from '../../context/UserContext';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const Login = props => {
  const [isNewPassword, setIsNewPassword] = useState(false);
  const [showNewPasswordModal, setShowNewPasswordModal] = useState(false);
  const [showEye, setShowEye] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorModal, setShowErrorModal] = useState(false);
  const { authenticate, error, loading } = useContext(UserContext);

  const initialValues = {
    email: '',
    password: ''
  };

  const [values, setValues] = useState(initialValues);

  const captchaRef = useRef(null);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const handleRecaptcha = () => setRecaptchaToken(captchaRef.current.getValue());

  const handleErrorModalClose = () => setShowErrorModal(false);

  const setValue = (key, value) => {
    setValues({
      ...values,
      [key]: value
    });
  };

  const handleChange = e => setValue(
    e.target.getAttribute('name'),
    e.target.value
  );

  const handleEye = () => { 
    setShowEye(!showEye);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleNewPasswordModalClose = () => { 
    setShowNewPasswordModal(false);
  };

  useEffect(() => {
    setIsNewPassword(props?.location?.state?.isNewPassword);

    if (props?.location?.state?.isNewPassword) {
      setShowNewPasswordModal(true);
    }

    if (isNewPassword) {
      console.log(isNewPassword);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (error) {
      setShowModal(true);
    }
  }, [error]);

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      const response = await authenticate({
        email: values.email,
        password: values.password,
        recaptchaToken
      });

      if (response?.error) {
        setErrorMessage(response?.error);
        setShowErrorModal(true);

        return;
      }
    } catch (err) {
      console.log(err);
    } finally {
      captchaRef?.current?.reset();
      setRecaptchaToken(null);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.form_container}>
        <div className={styles.logo}>
          <div>
            <img className={styles.logoImg} src="../assets/img/fesaude-logo2.png" alt="Logo FeSaúde" />
          </div>
          <div>
            <h1 className={styles.title}>Login</h1>
          </div>
        </div>

        <Form onSubmit={handleSubmit} noValidate>
          <div className={styles.form}>
            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="email">
                  <Form.Label>*e-mail:</Form.Label>
                  <Form.Control
                    className={styles.input}
                    type="email"
                    required
                    name="email"
                    onChange={handleChange}
                    value={values.email}
                  />
                </Form.Group>
              </div>
            </div>

            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="password">
                  <Form.Label>*Senha:</Form.Label>
                  <div className={styles.eye_container}>
                    <Form.Control
                      className={styles.input}
                      type={showEye ? 'text' : 'password'}
                      required
                      name="password"
                      onChange={handleChange}
                      value={values.password}
                    />
                    {showEye && (
                      <FaEyeSlash className={styles.eye} onClick={handleEye} />
                    )}

                    {!showEye && (
                      <FaEye className={styles.eye} onClick={handleEye} />
                    )}
                  </div>
                </Form.Group>
                
                <Modal show={showModal} onHide={handleModalClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>Erro</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>{error}</Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalClose}>
                      Fechar
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal show={showNewPasswordModal} onHide={handleNewPasswordModalClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>Sucesso</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>Sua senha foi definida com sucesso!</Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleNewPasswordModalClose}>
                      Fechar
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal show={showErrorModal} onHide={handleErrorModalClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>Erro!</Modal.Title>
                  </Modal.Header>
                  <Modal.Body className={styles.modal_body}>{errorMessage}</Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleErrorModalClose}>
                      Fechar
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
            <NavLink to="/esqueci-senha" className={styles.link}>Esqueci a senha / Primeiro acesso</NavLink>
          </div>
          
          <div className={styles.captcha_container}>
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              ref={captchaRef}
              onChange={handleRecaptcha}
              onExpired={() => setRecaptchaToken(null)}
            />
          </div>

          <div className={styles.button}>
            {loading && (
              <Button
                variant="flat"
                disabled
                className={styles.btn}
                type="submit"
              >
                Enviando...
              </Button>
            )}

            {!loading && (
              <Button
                variant="flat"
                className={styles.btn}
                type="submit"
                disabled={!recaptchaToken ? true : false}
              >
                Entrar
              </Button>
            )}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Login;
